(() => {
  const gate = document.querySelector('[data-kk-age-gate]');
  if (!gate) return;

  const storageKey = 'kk:age-verified:v1';
  const root = document.documentElement;
  const accept = gate.querySelector('[data-kk-age-accept]');
  const focusable = Array.from(gate.querySelectorAll('button:not([disabled]), a[href]'));
  const backgroundState = [];
  const managedBackground = new WeakSet();
  let backgroundObserver = null;

  const hasConsent = () => {
    try {
      return window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const rememberConsent = () => {
    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // The current page still unlocks if storage is unavailable.
    }
  };

  const restoreBackground = () => {
    backgroundState.forEach(({ element, inert, ariaHidden }) => {
      element.inert = inert;
      if (ariaHidden === null) {
        element.removeAttribute('aria-hidden');
      } else {
        element.setAttribute('aria-hidden', ariaHidden);
      }
    });
  };

  const lockBackgroundElement = (element) => {
    if (!(element instanceof HTMLElement) || element === gate || ['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName) || managedBackground.has(element)) return;
    managedBackground.add(element);
    backgroundState.push({
      element,
      inert: element.inert,
      ariaHidden: element.getAttribute('aria-hidden'),
    });
    element.inert = true;
    element.setAttribute('aria-hidden', 'true');
  };

  const removeGate = () => {
    root.classList.add('kk-age-verified');
    root.classList.remove('kk-age-lock');
    document.removeEventListener('keydown', containKeyboard, true);
    document.removeEventListener('focusin', containFocus, true);
    backgroundObserver?.disconnect();
    restoreBackground();
    gate.remove();

    const main = document.getElementById('MainContent');
    if (main) main.focus({ preventScroll: true });
  };

  const containKeyboard = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.key !== 'Tab' || focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const containFocus = (event) => {
    if (!gate.contains(event.target)) accept?.focus({ preventScroll: true });
  };

  if (hasConsent()) {
    removeGate();
    return;
  }

  root.classList.add('kk-age-lock');
  Array.from(document.body.children).forEach(lockBackgroundElement);
  backgroundObserver = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(lockBackgroundElement);
    });
  });
  backgroundObserver.observe(document.body, { childList: true });

  document.addEventListener('keydown', containKeyboard, true);
  document.addEventListener('focusin', containFocus, true);
  accept?.addEventListener('click', () => {
    rememberConsent();
    removeGate();
  }, { once: true });

  window.requestAnimationFrame(() => accept?.focus({ preventScroll: true }));
})();
